const CORONA_STATS_URL = 'https://www.data4life.care/corona.json';
import GEOGRAPHY from './geography.json';
class CoronaNumbers {
  constructor() {
    this.data = {};
    this.states = [];
    this.geography = '';
  }

  formatNumber(value) {
    if (window.Intl) {
      return new Intl.NumberFormat(document.documentElement.lang).format(value);
    }

    return value;
  }

  formatPercentage(value, withIndicator) {
    const percentString = Number(value / 100).toLocaleString(document.documentElement.lang, {
      style: 'percent',
      minimumFractionDigits: 2,
    });
    return withIndicator && value > 0 ? '+' + percentString : percentString;
  }

  formatDate(value) {
    const date = new Date(value);

    if (window.Intl) {
      return new Intl.DateTimeFormat(document.documentElement.lang, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(date);
    }

    return date.toLocaleString();
  }

  render() {
    const elements = [...document.querySelectorAll('[data-corona-number]')];

    Object.keys(this.data).forEach(key => {
      return elements
        .filter(({ dataset }) => dataset.coronaNumber === key)
        .forEach(element => {
          if (key.includes('_updated')) {
            element.innerHTML = this.formatDate(this.data[key]);
          } else if (key.includes('_perc')) {
            element.innerHTML = this.formatPercentage(this.data[key], key.includes('diff_'));
          } else if (key === `today_${this.geography.toLowerCase()}_recovered`) {
            element.innerHTML = '&asymp;' + this.formatNumber(this.data[key]);
          } else {
            element.innerHTML = this.formatNumber(this.data[key]);
          }
        });
    });

    window.dispatchEvent(
      new CustomEvent('coronaNumbersRendered', {
        detail: this.states.reduce(
          (mapping, state) => ({ ...mapping, [state.toLowerCase()]: state }),
          {}
        ),
      })
    );
  }

  fetch() {
    if (document.querySelector('[data-corona-geography]')) {
      this.geography = document
        .querySelector('[data-corona-geography]')
        .dataset.coronaGeography.toUpperCase();
    } else {
      this.geography = 'GERMANY';
    }

    fetch(CORONA_STATS_URL)
      .then(response => response.json())
      .then(data => {
        this.data = data[`${this.geography}`].data;

        if (this.geography === 'GERMANY') {
          this.states = GEOGRAPHY[this.geography].STATES;
        }

        this.render();
      })
      .catch(e => console.error(e));
    setTimeout(this.fetch.bind(this), 300000);
  }
}

const coronaNumbers = new CoronaNumbers();

const init = () => coronaNumbers.fetch();
const render = () => coronaNumbers.render();
export { init, render };
